// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

// App Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeContractDetailList} from "./contractDetailListSlice";
import {getContractCsList} from "../ContractClient";
import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";


// Main Function
export default function ContractCsListDrawer() {


    // ****************** BEGIN STATES ****************************

    const [contractCsList, setContractCsList] = useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const selectorContractId = useSelector((state) => state.contractDetailListSlc.value.contractId);
    const selectorContractName = useSelector((state) => state.contractDetailListSlc.value.contractName);
    const selectorCsListDrawerState = useSelector((state) => state.contractDetailListSlc.value.csListDrawerState);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchContractCsList = () =>
        getContractCsList(selectorContractId)
            .then(data => {
                console.log("this as my response");
                console.log(data);
                setContractCsList(data);
            });

// ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        fetchContractCsList();
    }, [ useSelector((state) => state.contractDetailListSlc.value.csListDrawerState)===true]);

// ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    function closeContractCsListDrawer() {
        dispatchData(changeContractDetailList({id: 0, csListDrawerState: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN MISC ***************************

    const renderContractCsList = contractCsList => {
        if (contractCsList.length <= 0) {
            return "No Data";
        }}

    // *************** END MISC *******************************



    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = contractCsList => [

        {
            field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            editable: false,
            width: 50,
            hide: true,
        },
        {    field: 'sectionOrdinal',
            headerName: 'Section #',
            description: '',
            sortable: true,
            width: 100,
            hide: false,
        },
        {    field: 'sectionLevel',
            headerName: 'Level',
            description: '',
            sortable: true,
            width: 100,
            hide: false,
        },
        {
            field: 'sectionName',
            headerName: 'Name',
            description: '',
            sortable: false,
            editable: true,
            width: 700,
        },
        {
            field: 'sectionDescription',
            headerName: 'Description',
            description: '',
            sortable: true,
            editable: true,
            hide: true,
            // editable: true,
            width: 500,
        },

    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 1000 },
                }}
                anchor='right'
                open={selectorCsListDrawerState}
                initialState={{open: false}}
                onClose={closeContractCsListDrawer}
            >
                <Box style={{cursor:'pointer'}} sx= {{pl: 2}}>
                    <h1 onClick={() => closeContractCsListDrawer()}>Contract Section List</h1>
                    <Stack direction="row" spacing={1}>
                        {/*<Typography component="span">id:</Typography>*/}
                        {/*<Typography component="span" fontWeight="bold">{selectorContractId}</Typography>*/}
                        {/*<Box sx={{ ml: 6 }} /> /!* Adds extra spacing before 'name:' *!/*/}
                        {/*<Typography component="span">name:</Typography>*/}
                        <Typography component="span" fontWeight="bold">{selectorContractName}</Typography>
                    </Stack>
                </Box>
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"ContractCsList"}
                    rows={contractCsList}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(contractCsList)}
                    density={"compact"}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    rowKey={contractCsList => contractCsList.id}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
